export const API_BASE_URL = "https://bg.nomis.cc/api";
export const scoreName = "ton";
